module.exports = __webpack_public_path__ + "static/media/icon_male.8d34ae75.png";